import React from 'react'
import { useSelector } from 'react-redux'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import CloseIcon from '@mui/icons-material/Close'
import defaultTexts from '../../../texts/texts'
import RegionServiceItem from './RegionServiceItem'

const RegionItem = (props) => {
  const {
    is_default,
    region_name,
    subscriptionName,
    serviceNames,
    identityServiceName,
    services,
    setRegions,
    sx,
    handleServiceEditDialogOpen,
    handleRegionDeleteDialogOpen,
  } = props
  const theme = useTheme()
  
  const user_role = useSelector(state => state.profile.user_role)
  const editPermission = user_role === 'superadmin' || user_role === 'owner' || user_role === 'admin'

  const regionLabelStyle = {
    height: '50px',
    padding: '0px 10px',
    color: 'white',
    fontSize: '14px',
    fontWeight: '500',
    borderRadius: '10px 10px 0px 0px',
    position: 'relative'
  }
  
  const regionHideIconStyle = {
    position: 'absolute',
    top: '-18px',
    right: '-18px',
    background: theme.palette.azureishWhite,

    '&:hover': {
      background: alpha(theme.palette.azureishWhite, 0.7),
    }
  }

  const handleHideRegion = () => {
    setRegions(prev => prev.filter(item => item.region_name !== region_name))
  }

  const handleClickDelete = () => {
    handleRegionDeleteDialogOpen({
      region_name,
      title: defaultTexts.deleteRegion,
    })   
  }
  
  return (
    <Box
      sx={{
        padding: '24px 24px 0px 0px',
        ...sx,
      }}
    >
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='flex-start'
        spacing={1}
        sx={{
          ...regionLabelStyle,
          background: is_default ? theme.palette.oxfordBlue : theme.palette.violetsAreBlue,
        }}
      >
        <Box>{region_name}{is_default && ' (' + defaultTexts.default + ')'}</Box>

        {
          (editPermission && !is_default) &&
          <IconButton onClick={handleClickDelete}>
            <DeleteIcon sx={{ color: 'white' }} />
          </IconButton>
        }
        
        <IconButton sx={regionHideIconStyle} onClick={handleHideRegion}>
          <CloseIcon sx={{ color: is_default ? theme.palette.oxfordBlue : theme.palette.violetsAreBlue }} />
        </IconButton>
      </Stack>

      {
        serviceNames.map((item, index) => (
          <RegionServiceItem
            key={index}
            subscriptionName={subscriptionName}
            service_name={item}            
            region_name={region_name}
            services={services}
            identityServiceName={identityServiceName}
            handleServiceEditDialogOpen={handleServiceEditDialogOpen}
          />
        ))
      }

    </Box>
  )
}

export default RegionItem